import { render, staticRenderFns } from "./CurationFilterReceiveLayout.vue?vue&type=template&id=79810d7a&scoped=true"
import script from "./CurationFilterReceiveLayout.vue?vue&type=script&lang=js"
export * from "./CurationFilterReceiveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79810d7a",
  null
  
)

export default component.exports